import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  title: {
    width: '45%',

    '& > :first-child > :first-child': {
      // @ts-ignore
      color: theme.palette.indicator.green
    },

    [theme.breakpoints.down('lg')]: {
      width: '100%'
    }
  }
}))

export default useStyles
